import React from 'react'
import { Link } from 'react-router-dom'

export type ApplicationStatusKey =
  | 'applied'
  | 'scanning'
  | 'screening'
  | 'interview'
  | 'hired'
  | 'rejected'

export interface RecentOfferListItemProps {
  id: number
  jobTitle: string
  byStatus: Record<ApplicationStatusKey, number>
  statusLabels: Record<ApplicationStatusKey, string>
  mutedBackground?: boolean
}

const statusStyles: Record<ApplicationStatusKey, string> = {
  applied: 'bg-muted text-foreground',
  scanning: 'bg-[#3B82F6]/15 text-[#1D4ED8]',
  screening: 'bg-[#F59E0B]/15 text-[#B45309]',
  interview: 'bg-[#19A6A6]/15 text-[#0F766E]',
  hired: 'bg-[#22C55E]/15 text-[#15803D]',
  rejected: 'bg-[#EF4444]/15 text-[#B91C1C]',
}

const statusOrder: ApplicationStatusKey[] = [
  'applied',
  'scanning',
  'screening',
  'interview',
  'hired',
  'rejected',
]

const displayStatusOrder = statusOrder.filter((status) => status !== 'applied')

export function RecentOfferListItem({
  id,
  jobTitle,
  byStatus,
  statusLabels,
  mutedBackground = false,
}: RecentOfferListItemProps) {
  const totalCandidates = statusOrder.reduce((sum, status) => sum + (byStatus[status] || 0), 0)

  return (
    <Link
      to={`/offers/${id}`}
      className={`box-border flex w-full flex-col gap-2 rounded-[6px] px-3 py-3 transition-colors duration-150 sm:px-4 ${
        mutedBackground ? 'bg-muted/60 hover:bg-muted/80' : 'bg-card hover:bg-accent/30'
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground">{jobTitle}</p>
        <span className="shrink-0 rounded-full bg-[#575757] px-2.5 py-1 text-xs font-semibold text-white">
          {totalCandidates}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-1.5 sm:grid-cols-3">
        {displayStatusOrder.map((status) => (
          <div
            key={status}
            className={`flex items-center justify-between gap-1 rounded-[4px] px-2 py-1 text-[11px] font-medium ${statusStyles[status]}`}
          >
            <span className="truncate">{statusLabels[status]}</span>
            <span className="shrink-0 font-semibold">{byStatus[status] || 0}</span>
          </div>
        ))}
      </div>
    </Link>
  )
}
